<template>
  <div>
    <CreateAn1 :planData="planData"></CreateAn1>
    <div class="createrAn-Buttom-box" :style="'justify-content: center'">
      <div class="createrAn-Buttom intro-x">
          <span class="span0 span1" @click="handleCancel">
            取消
          </span>
        <span class="span0 span2" @click="submit()">
            下一步
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import CreateAn1 from "@/modules/createAn1";

export default {
  components: { CreateAn1 },
  props: ["planData"],
  methods: {
    // 取消
    handleCancel() {
      this.$router.go(-1);
    },
    // 下一步
    handleNextStep() {
      this.$emit('handle-next', )
    },
    submit() {
      if ( this.planData.filter((item) => { return item.laber === true}).length >= 1) {
        this.handleNextStep()
      } else {
        this.$message.error("请选择功能板块");
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.createTitle {
  margin: 41px 0 15px;
  color: #2d3748;
  font-size: 18px;
  display: block;
}

.createHtml-box {
  overflow: hidden;
  background: #fff;
  border-radius: 22px;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
}

.createHtml {
  border-bottom: 1px solid #f5f5f5;
}

.createBody {
  width: 100%;
  background: #ffffff;
  border-radius: 22px;
}

.steps-box {
  padding: 40px 100px;
}

.createrAn-Buttom-box {
  widows: 100%;
  display: flex;
  width: 77.6%;
  padding: 40px 0 80px;
  margin: 0 auto;
  justify-content: space-between;
}

.createrAn-Buttom {
  .span0 {
    display: inline-block;
    width: 96px;
    height: 37px;
    line-height: 37px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 12px;
    cursor: pointer;
  }
  .span9 {
    display: inline-block;
    width: 208px;
    height: 37px;
    line-height: 37px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 12px;
    cursor: pointer;
  }

  .span1 {
    color: #788598;
    background: #edf1f6;
  }
  .span1:active {
    background: #f8f8f8;
  }

  .span2 {
    color: rgb(235, 233, 233);
    background: #1890ff;
    margin-left: 20px;
  }
  .span2:active {
    background: #2d97fa;
  }
}

.loading8Clss {
  background: #e2f0ff !important;
  cursor: no-drop !important;
  color: #ffffff !important;
}

.button {
  width: 236px;
  height: 37px;
  background: #1890ff;
  border-radius: 12px;
  text-align: center;
  display: inline-block;
  font-size: 14px;
  color: #fff;
}

.button:active {
  background: #399fff;
}

@media screen and (max-width: 600px) {
  .createHtml {
    display: none !important;
  }

  .createrAn-Buttom {
    display: flex !important;
    padding: 20px !important;
    justify-content: center;
    align-items: center;
    .span2 {
      margin-left: 20px !important;
    }
  }
}
</style>